import { formatDate } from '@angular/common';
import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_444 implements Validator {

	public static id = 'CTRL_444';
	private message = 'error.ctr_444';


	public LOG: LogService = new LogService(CTRL_444);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_444.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const dateFinDiffusionWithStepId = map.get(ctrl.value.rgCtrls.dateFinDiffusion);
    			const dateFinDiffusionCtrl = form.controls[dateFinDiffusionWithStepId];
				const toDay = new Date();
                if (dateFinDiffusionCtrl.value > formatDate(toDay.setDate(toDay.getDate() + 7), 'yyyy-MM-dd', 'en')) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
			}
		}
	}
}
